<template>
    <div class="order-address-plugin-form order-voucher">

        <div v-show="success" class="text-container">
            <h2>Danke für deine Bestellung beim Öpfelchasper.</h2>
            <p>
                Vielen Dank für deine Bestellung beim Öpfelchasper, wir bearbeiten sie so schnell wie möglich.<br>
                Die Bestellbestätigung erhältst du schon bald per E-Mail.<br>
                <br>
                Hast du noch Fragen? Wir beantworten dir sie gerne unter <a href="tel:+41438186152">043 818 61 52</a> oder per E-Mail unter <a href="mailto:info@oepfelchasper.ch">info@oepfelchasper.ch</a>.
            </p>
        </div>

        <div v-show="error" class="text-container">
            <p>
                Deine Bestellung konnte nicht übermittelt werden.<br>
                Bitte versuche es später noch einmal oder kontaktiere uns per Telefon oder E-Mail:<br>
                <br>
                <a href="tel:+41438186152">043 818 61 52</a><br>
                <a href="mailto:info@oepfelchasper.ch">info@oepfelchasper.ch</a>
            </p>
            <p>
                <a
                    href="#"
                    class="order-address-form__link--before"
                    @click.prevent="showForm"
                >
                    Zurück
                </a>
            </p>
        </div>

        <div v-show="(!success && !error)">

            <h2 class="order-address-form__heading">
                Beträge
            </h2>

            <form @submit="validateForm">
                <div class="form-group order-voucher__amounts">
                    <div class="order-voucher__amounts--predefined">
                        <div
                            class="radio"
                            v-for="(amount, index) in amountsPredefined"
                            :key="`amount-${index}`"
                        >
                            <label>
                                <input :checked="index === 0" name="amount" type="radio" :value="amount" v-model="amountSelected">
                                <span class="custom-radio"/>
                                {{ amount }} CHF
                            </label>
                        </div>
                    </div>
                    <div class="order-voucher__amounts--custom">
                        <div class="form-group">
                            <div class="radio">
                                <label>
                                    <input name="amount" type="radio" value="0" v-model="amountSelected">
                                    <span class="custom-radio"/>
                                    Eigener Betrag
                                </label>
                            </div>
                            <input
                                class="form-control order-voucher__amounts__custom"
                                :class="{ 'error': $v.amountSpecific.$error }"
                                name="amount-custom"
                                type="number"
                                @focus="setSpecificAmount"
                                @input="updateSpecificAmount"
                                v-model.trim="amountSpecific"
                                min="0"
                            >
                        </div>
                    </div>
                </div>

                <address-form
                    ref="addressForm"
                    :validate-form="validateForm"
                    :comment-text="'Hier kannst du eine Nachricht an den Beschenkten eingeben.'"
                    disable-early-invoice
                />
            </form>

            <div class="order-address-plugin-form__btn-container">
                <a
                    href="#"
                    class="btn btn-default"
                    @click.prevent="validateForm"
                >
                    Gutschein bestellen
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line
import { validationMixin } from 'vuelidate';
import {
    minValue,
    numeric,
} from 'vuelidate/lib/validators';

import AddressForm from '../Forms/Address.vue';

export default {
    components: {
        AddressForm,
    },
    mixins: [validationMixin],
    props: {
        amountsPredefined: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            error: false,
            success: false,
            amountSelected: this.amountsPredefined[0],
            amountSpecific: '',
        };
    },
    validations() {
        return {
            amountSpecific: {
                numeric,
                minValue,
            },
        };
    },
    methods: {
        setSpecificAmount() {
            this.amountSelected = '0';
        },
        updateSpecificAmount(e) {
            this.$v.amountSpecific.$touch();
            this.amountSpecific = e.target.value;
            this.amountSelected = '0';
        },
        validateForm() {
            const $heading = $('.order-address-form__heading');
            // check for errors and empty, required fields
            this.$v.$touch();
            this.$refs.addressForm.$refs.invoiceAddress.$v.$touch();
            this.$refs.addressForm.$refs.deliveryAddress.$v.$touch();
            // if there are errors, jump to make them visible to the user
            if (this.$refs.addressForm.$refs.deliveryAddress.$v.form.$invalid ||
                this.$refs.addressForm.$refs.deliveryAddress.$v.form.$error ||
                this.$refs.addressForm.$refs.invoiceAddress.$v.form.$invalid ||
                this.$refs.addressForm.$refs.invoiceAddress.$v.form.$error ||
                this.$v.$invalid ||
                this.$v.$error
            ) {
                window.scrollTo(0, $heading.offset().top);
            } else { // if no errors, send order
                this.sendOrder();
            }
        },
        sendOrder() {
            // when radio button value is 0, it's the specific amount, else use selected radio button value
            const amount = Number(this.amountSelected) === 0 ? this.amountSpecific : this.amountSelected;
            const addressForm = this.$refs.addressForm;
            const { invoiceAddress } = addressForm.$refs.invoiceAddress.form;
            const { deliveryAddress } = addressForm.$refs.deliveryAddress.form;

            // show loading modal
            this.$store.dispatch('showLoadingModal', {
                message: 'Deine Bestellung wird bearbeitet.',
            });

            // prepare order, save addresses
            this.$store.dispatch('updateOrder', {
                invoiceAddress,
                deliveryAddress,
                attentionBy: addressForm.$refs.deliveryAddress.form.attention_by,
                comment: addressForm.$refs.deliveryAddress.form.comment,
            });

            // send order to whatwedo API
            this.$store.dispatch('sendOrderVoucher', { amount })
                .then(
                    () => {
                        this.$store.dispatch('hideLoadingModal'); // hide loading
                        this.success = true;
                        this.addDataLayerEvent();
                        $('#order-plugin-header-text, #order-plugin-header-image').hide();
                    },
                    () => {
                        // error handling
                        this.$store.dispatch('hideLoadingModal'); // hide loading
                        this.error = true;
                        $('#order-plugin-header-text, #order-plugin-header-image').hide();
                    },
                );
        },
        addDataLayerEvent() {
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'gift-voucher-form.sent',
                });
            }
        },
        showForm() {
            this.error = false;
            $('#order-plugin-header-text, #order-plugin-header-image').show();
        },
    },
};
</script>




// WEBPACK FOOTER //
// Voucher.vue?d18adb7e